import cx from 'classnames';
import { UserIcon } from '@ornikar/kitt-icons';
import type { ReactNode } from 'react';
import type { Except } from 'type-fest';
import { deprecate } from '../../utils/deprecate';
import { Typography } from '../Typography';
import styles from './styles.module.css';

const getFirstCharacter = (string: string): string => (string ? string[0] : '');

const getInitials = (firstname: string, lastname: string): string =>
  (getFirstCharacter(firstname) + getFirstCharacter(lastname)).toUpperCase();

export interface AvatarProps {
  src?: string | null;
  alt?: string;
  firstname?: string | null;
  lastname?: string | null;
  large?: boolean;
  light?: boolean;
}

function AvatarContent({ src, alt = '', firstname, lastname, large }: Except<AvatarProps, 'light'>): ReactNode {
  if (src) {
    return <img src={src} alt={alt} />;
  }

  if (firstname && lastname) {
    const initials = getInitials(firstname, lastname);

    return large ? (
      <Typography.div base="body-large" variant="bold" color="white">
        {initials}
      </Typography.div>
    ) : (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>{initials}</>
    );
  }

  return (
    <div className={styles.DefaultAvatar}>
      <UserIcon />
    </div>
  );
}

/** @deprecated use Avatar from kitt-universal instead */
export function Avatar({ light, ...props }: AvatarProps): ReactNode {
  if (__DEV__) deprecate(Avatar.name, 'Use Avatar from kitt-universal instead');
  return (
    <div
      className={cx(styles.AvatarWrapper, {
        [styles.TextAvatar]: !props.src,
        [styles.Large]: props.large,
        [styles.Light]: light,
      })}
    >
      <AvatarContent {...props} />
    </div>
  );
}
